import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {StorageService} from '../../@core/services/storage.service';
import {AQH_CLS_0} from '../models/input.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClassesService {

  constructor(private endpointService: EndpointService,
              private storageService: StorageService) {
  }

  getClasses(params: AQH_CLS_0) {
    return this.endpointService.aqh_cls_0(params).pipe(map((data => {
      return data;
    })));
  }
}
